// Plain Vietnamese labels for codes shown to people (never used for authorization).
export const ROLE_TEXT: Record<string, string> = { CTV: "Cộng tác viên", DEALER: "Đại lý", KHO: "Kho / tư vấn", ACCOUNTANT: "Kế toán", OWNER: "Owner", PENDING: "Chờ Owner duyệt" };
export const USER_STATE: Record<string, { text: string; tone: "ok" | "wait" | "bad" | "demo" }> = {
  ACTIVE: { text: "Đang hoạt động", tone: "ok" },
  WAITING_OWNER: { text: "Chờ Owner duyệt", tone: "wait" },
  PROFILE_INCOMPLETE: { text: "Chưa xong hồ sơ", tone: "demo" },
  REJECTED: { text: "Chưa duyệt", tone: "bad" },
  INACTIVE: { text: "Ngừng hoạt động", tone: "bad" },
};
